import React                 from 'react';
import { isNullOrUndefined } from 'rewire-common';
import { Observe }           from 'rewire-core';
import {
  IGridFontSizes,
  DragAndDrop,
}                            from 'rewire-grid';
import { WithStyle }         from 'rewire-ui';
import { Theme }             from '@material-ui/core/styles';
import Typography            from '@material-ui/core/Typography';
import Grid                  from '../ui/Grid';
import Loader                from '../ui/Loader';
import DuplicateJobDialog    from './DuplicateJobDialog';
import DuplicateJobsDialog   from './DuplicateJobsDialog';
import ScheduleInfoPanel     from './ScheduleInfoPanel';
import ScheduleToolbar       from './ScheduleToolbar';
import scheduleModel         from './ScheduleModel';
import { withStyles }        from '../utility/styles';

const styles = (theme: Theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    minHeight: '140px',
  },
  scheduleContainer: {
    display: 'flex',
    flex: '1 1 auto',
    minWidth: '508px',
    flexDirection: 'column',
  },
  loading: {
    height: '100%',
    cursor: 'wait',
  },
  gridLeftLabels: {
    borderRight: `1px solid ${theme.palette.primary.light}`,
  },
  gridCornerLabels: {
    borderRight: `1px solid ${theme.palette.primary.light} !important`,
  },
});

interface IScheduleProps {
}

type ScheduleProps = WithStyle<ReturnType<typeof styles>, IScheduleProps>;

class Schedule extends React.Component<ScheduleProps> {
  constructor(props: ScheduleProps) {
    super(props);
  }

  componentWillUnmount() {
    scheduleModel.reset();
  }

  renderScheduleGrid = React.memo((): JSX.Element => {
    const gridFontSizes: IGridFontSizes = {
      header:     '0.9em',
      body:       '0.8em',
      groupRow:   '1em',
      toggleMenu: '0.85em',
    };
    return (
      < >
      <Observe render={() => (
          <Loader loading={scheduleModel.isLoading}>
            <Observe render={() => {
              const gridComponent = <Grid key={scheduleModel.grid.id} grid={scheduleModel.grid} gridFontSizes={gridFontSizes} classes={{leftLabels: this.props.classes.gridLeftLabels, cornerLabels: this.props.classes.gridCornerLabels}} />;
              const scheduleGrid  = !scheduleModel.gridIsReorderable && !scheduleModel.viewOnly
                ? <DragAndDrop>{gridComponent}</DragAndDrop>
                : gridComponent;

              return (
                (scheduleModel.hasResults || scheduleModel.hasRows)
                  ? !isNullOrUndefined(scheduleModel.grid.id) &&
                    scheduleGrid || null
                  : !scheduleModel.isLoading && <Typography variant='h5'>No Results</Typography>
              );
            }} />
          </Loader>
      )}/>
      <DuplicateJobDialog />
      <DuplicateJobsDialog />
      </>
    );
  });

  render() {
    const {classes} = this.props;

    return <Observe render={() => (
      <div className={classes.root}>
        <div id='schedule-container' className={classes.scheduleContainer}>
          <ScheduleToolbar />
          <this.renderScheduleGrid />
        </div>
        <ScheduleInfoPanel />
      </div>
    )} />;
  }
}

export default withStyles<IScheduleProps>(styles, Schedule);
